module.exports = {"540527100":"洛扎镇","540527101":"拉康镇","540527200":"生格乡","540527201":"边巴乡","540527202":"扎日乡","540527203":"色乡","540527204":"拉郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540527.json
// module id = 2534
// module chunks = 0